import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { Typography } from '../../../shared/constants/Typographies';

export const LinkBox = styled.a``;

export const PromoCard = styled.div`
  text-align: center;

  a {
    width: 100%;
    text-decoration: none;
    text-align: center;
    justify-content: center;
  }
`;

export const Title = styled.p`
  ${Typography.XXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 20px 10px;
`;
